<template>
    <v-col class="pt-0" cols="12" sm="12">
<!-- >>> Upper Tabs -->
        <v-row>
            <v-col class="pt-0" cols="12" sm="12">
                <v-tabs
                    v-model="data[leg].input_FlightDateType" background-color="#f5f5f5"
                    class="sdr-custom-tabs"
                    @change="onChange_TabChange">
                    <v-tab active-class="sdr-custom-tab-active">
                        Single Date(s)
                    </v-tab>
                    <v-tab
                        :disabled="editorMode === 'update'"
                        active-class="sdr-custom-tab-active"
                        >
                        Weekly Range
                    </v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <!-- <<< Upper Tabs -->


        <!-- >>> Title -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <h2 v-if="leg === 'firstLeg'" class="mb-8">
                    First Leg
                </h2>
                <h2 v-if="leg === 'secondLeg'" class="mb-8">
                    Second Leg
                </h2>
            </v-col>
        </v-row>
        <!-- <<< Title -->


        <!-- >>> Date Tabs -->
        <v-tabs-items v-model="data[leg].input_FlightDateType">
            <!-- >>> DATES (0) -->
            <v-tab-item eager>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-menu
                            ref="dates_dateMenu"
                            v-model="dates_dateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-combobox
                                    v-model="formattedDatesStartDate"
                                    class="sdr-custom-dates-combobox"
                                    v-bind="attrs"
                                    :rules ="[
                                        showDeleteCheckbox ? true : rules.reqIfActiveTab(data[leg].input_dates_dates, data[leg].input_FlightDateType === 0),
                                    ]"
                                    clearable
                                    readonly
                                    v-on="on">
                                    <template v-slot:label>
                                        Dates <span style="color: red; font-size: 1.4rem;">*</span>
                                    </template>

                                    <!-- >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #182 -->
                                    <template v-slot:selection="{ item }">
                                        <v-chip close @click:close="onClick_dates_dateMenu_deleteItem(item)">
                                            {{ item | dayjsUtcDe({ showDayName: true }) }}
                                        </v-chip>
                                    </template>
                                    <!-- <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #182 -->
                                </v-combobox>
                            </template>
                            <v-date-picker
                                v-model="data[leg].input_dates_dates"
                                :first-day-of-week="1"
                                no-title>
                                <v-spacer />
                                <v-btn
                                    text
                                    color="primary"
                                    @click="dates_dateMenu = false">
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="onChange_dates_SaveStartDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-tab-item>
            <!-- <<< DATES (0) -->

            <!-- >>> WEEKLY (1) -->
            <v-tab-item v-if="data[leg].input_FlightDateType === 1" eager>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-select
                            v-model="data[leg].input_weekly_DaysOfWeek"
                            :items="items_weekly_DaysOfWeek"
                            :rules ="[
                                 rules.reqIfWeekly(data[leg].input_weekly_DaysOfWeek, data[leg].input_FlightDateType),
                            ]"
                            item-text="text"
                            name="input_weekly_DaysOfWeek"
                            multiple
                            chips
                            prepend-icon="mdi-view-day"
                            return-object
                            @change="onChange_weekly_DaysOfWeek">
                            <template v-slot:label>
                                <p class="mb-0">
                                    Series Day(s) <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="4" style="display:flex;align-items:center;">
                        <v-menu
                            ref="weekly_startDateMenu"
                            v-model="weekly_startDateMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    ref="input_weekly_StartDate"
                                    v-model="formattedWeeklyStartDate"
                                    v-bind="attrs"
                                    prepend-icon="mdi-clock-start"
                                    clearable
                                    :rules ="[
                                         rules.reqIfWeekly(data[leg].input_weekly_StartDate, data[leg].input_FlightDateType),
                                    ]"
                                    readonly
                                    v-on="on">
                                    <template v-slot:label>
                                        Series starts on <span style="color: red; font-size: 1.4rem;">*</span>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="data[leg].input_weekly_StartDate"
                                :first-day-of-week="1"
                                :min="editorMode === 'extend' ? get_flights_lastDateOfSimilarFlights.add(1, 'day').format('YYYY-MM-DD') : undefined"
                                @change="onChange_weekly_SaveStartDate" />
                        </v-menu>
                    </v-col>

                    <v-col style="display: flex; align-items:center" cols="12" sm="1">
                        <img style="height:120px;" src="../../../../../../../assets/gant.svg">
                    </v-col>

                    <v-col style="background:#f5f5f5;border-radius:4px;" cols="12" sm="7" class="pt-6">
                        <div style="width:100%">
                            <v-row>
                                <v-col cols="12" sm="3" class="mt-2">
                                    <p style="text-align:right;font-size:1.1rem;font-weight:bold;">
                                        and ends on
                                    </p>
                                </v-col>
                                <v-col cols="12" sm="8" class="pt-0">
                                    <v-menu
                                        ref="weekly_endDateMenu"
                                        v-model="weekly_endDateMenu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                ref="input_weekly_EndDate"
                                                v-model="formattedWeeklyEndDate"
                                                v-bind="attrs"
                                                clearable
                                                :rules ="[
                                                     rules.reqIfWeekly(data[leg].input_weekly_EndDate, data[leg].input_FlightDateType),
                                                ]"
                                                readonly
                                                v-on="on">
                                                <template v-slot:label>
                                                    Date <span style="color: red; font-size: 1.4rem;">*</span>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="data[leg].input_weekly_EndDate"
                                            :first-day-of-week="1"
                                            :min="editorMode === 'extend' ? get_flights_lastDateOfSimilarFlights.add(1, 'day').format('YYYY-MM-DD') : null"
                                            @change="onChange_weekly_SaveEndDate" />
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3" />
                                <v-col style="display:flex;justify-content:center;" cols="12" sm="8">
                                    <v-icon style="text-align:center;font-size:1.5rem;" color="primary">
                                        mdi-swap-vertical
                                    </v-icon>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <p style="text-align:right;font-size:1.1rem;font-weight:bold;" class="ma-0 pt-2">
                                        or ends after
                                    </p>
                                </v-col>
                                <v-col cols="12" sm="8" class="pt-0">
                                    <v-text-field
                                        ref="input_weekly_NumberOfWeeks"
                                        v-model="data[leg].input_weekly_NumberOfWeeks"
                                        name="input_weekly_NumberOfWeeks"
                                        type="number"
                                        clearable
                                        :rules ="[
                                             rules.reqIfWeekly(data[leg].input_weekly_NumberOfWeeks, data[leg].input_FlightDateType),
                                        ]"
                                        @change="onChange_weekly_SaveWeeks">
                                        <template v-slot:label>
                                            Weeks <span style="color: red; font-size: 1.4rem;">*</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-tab-item>
            <!-- <<< WEEKLY (1) -->
</v-tabs-items>
        <!-- >>> Date Tabs -->
</v-col>
</template>

<script>
    import Vue from 'vue';
    import dayjs from 'dayjs';
    import { mapGetters } from 'vuex';
    import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
    dayjs.extend(isSameOrBefore);


    export default {
        name: 'SdrStep2Dateconfig',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire 'rules' Object
            onChange_TabChange: Function,
            showDeleteCheckbox: Boolean

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                items_weekly_DaysOfWeek: [
                    {
                        text: '1',
                        value: 'MONDAY',
                        dayOfWeek: 1
                    },
                    {
                        text: '2',
                        value: 'TUESDAY',
                        dayOfWeek: 2
                    },
                    {
                        text: '3',
                        value: 'WEDNESDAY',
                        dayOfWeek: 3
                    },
                    {
                        text: '4',
                        value: 'THURSDAY',
                        dayOfWeek: 4
                    },
                    {
                        text: '5',
                        value: 'FRIDAY',
                        dayOfWeek: 5
                    },
                    {
                        text: '6',
                        value: 'SATURDAY',
                        dayOfWeek: 6
                    },
                    {
                        text: '7',
                        value: 'SUNDAY',
                        dayOfWeek: 0
                    }

                ],
                dates_dateMenu: null,
                weekly_startDateMenu: null,
                weekly_endDateMenu: null
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {


            ...mapGetters([
                'get_flights_lastDateOfSimilarFlights'
            ]),


            /*******************************************************************
            * formattedWeeklyStartDate{}
            *
            * Desc:
            * Note:
            *
            */
            formattedWeeklyStartDate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedWeeklyStartDate/get');
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_weekly_StartDate)) {
                        return;
                    }


                    return me.data[me.leg].input_weekly_StartDate ? this.formatDateForTextField(me.data[me.leg].input_weekly_StartDate) : '';

                }, // eo function formattedWeeklyStartDate get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedWeeklyStartDate/set');
                    me.data[me.leg].input_weekly_StartDate = value;
                    return me.data[me.leg].input_weekly_StartDate;

                } // eo function formattedWeeklyStartDate set()

            }, // eo function formattedWeeklyStartDate{}


            /******************************************************************* 'DateFields Formatter'
            * formattedDatesStartDate{}
            *
            * Desc:
            * Note:
            *
            */
            formattedDatesStartDate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedDatesStartDate/get');
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_dates_dates)) {
                        return;
                    }

                    // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #197
                    return me.data[me.leg].input_dates_dates;
                    // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #197

                }, // eo function formattedDatesStartDate get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedDatesStartDate/set');
                    me.data[me.leg].input_dates_dates = value;
                    return me.data[me.leg].input_dates_dates;

                } // eo function formattedDatesStartDate set()

            }, // eo function formatteddatesStartDate{}


            /*******************************************************************
            * formattedWeeklyEndDate{}
            *
            * Desc:
            * Note:
            *
            */
            formattedWeeklyEndDate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedWeeklyEndDate/get');
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_weekly_EndDate)) {
                        return;
                    }

                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/formattedWeeklyEndDate/get');
                    return me.data[me.leg].input_weekly_EndDate ? me.formatDateForTextField(me.data[me.leg].input_weekly_EndDate) : '';

                }, // eo function formattedWeeklyEndDate get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> computed/formattedWeeklyEndDate/set');
                    me.data[me.leg].input_weekly_EndDate = value;
                    return me.data[me.leg].input_weekly_EndDate;

                } // eo function formattedWeeklyEndDate set()

            } // eo function formattedWeeklyEndDate{}


        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_weekly_DaysOfWeek()
            *
            * Desc:
            * Note:
            *
            */
            onChange_weekly_DaysOfWeek: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_weekly_DaysOfWeek');
                me.setDatesInRange();

            }, // eo function onChange_weekly_DaysOfWeek()


            /******************************************************************* 'Listeners - DatePickers'
            * onChange_dates_SaveStartDate()
            *
            * Desc:
            * Note:
            *
            * @param {Object} date ()
            */
            onChange_dates_SaveStartDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_dates_SaveStartDate');
                me.$refs.dates_dateMenu.save(date);

            }, // eo function onChange_dates_SaveStartDate()


            // >>> 15.03.2022 - CAR<christian.arp@sundair.com>: #182
            /*******************************************************************
            * onClick_dates_dateMenu_deleteItem()
            *
            * Desc: Delete on click on an date item.
            * Note:
            *
            * @param {String} itemToDelete (iso date string)
            */
            onClick_dates_dateMenu_deleteItem: function(itemToDelete) {

                const me = this;
                let itemToDeleteIndex = -1;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onClick_dates_dateMenu_deleteItem');
                if (typeof me.formattedDatesStartDate === 'object') {
                    itemToDeleteIndex = me.formattedDatesStartDate.findIndex(date => date === itemToDelete);

                    if (itemToDeleteIndex > -1) {
                        me.formattedDatesStartDate.splice(itemToDeleteIndex, 1);
                    }
                }

                if (typeof me.formattedDatesStartDate === 'string') {
                    me.formattedDatesStartDate = '';
                }

            }, // eo function onClick_dates_dateMenu_deleteItem()
            // <<< 15.03.2022 - CAR<christian.arp@sundair.com>: #182


            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveStartDate()
            *
            * Desc:
            * Note:
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveStartDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_weekly_SaveStartDate');
                if (dayjs(me.data[me.leg].input_weekly_EndDate).isBefore(date)) {
                    me.data[me.leg].input_weekly_EndDate = date;
                    me.$refs.weekly_endDateMenu.save(date);
                    me.onChange_highlightField('input_weekly_EndDate');
                }

                me.$refs.weekly_startDateMenu.save(date);

                me.setDatesInRange();

                me.onChange_highlightField('input_weekly_NumberOfWeeks');

            }, // eo function onChange_weekly_SaveStartDate()



            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveEndDate()
            *
            * Desc:
            * Note:
            *
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveEndDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_weekly_SaveEndDate');
                if (dayjs(me.data[me.leg].input_weekly_StartDate).isAfter(date)) {
                    me.data[me.leg].input_weekly_StartDate = date;
                    me.$refs.weekly_startDateMenu.save(date);
                    me.onChange_highlightField('input_weekly_StartDate');
                }

                me.$refs.weekly_endDateMenu.save(date);

                me.setDatesInRange();

                me.onChange_highlightField('input_weekly_NumberOfWeeks');

            }, // eo function onChange_weekly_SaveEndDate()


            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveWeeks()
            *
            * Desc:
            * Note:
            *
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveWeeks: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_weekly_SaveWeeks');
                me.data[me.leg].input_weekly_EndDate = dayjs(me.data[me.leg].input_weekly_StartDate).add(me.data[me.leg].input_weekly_NumberOfWeeks, 'weeks').format('YYYY-MM-DD');
                me.setDatesInRange();
                me.onChange_highlightField('input_weekly_EndDate');

            }, // eo function onChange_weekly_SaveWeeks()


            /*******************************************************************
            * onChange_highlightField{}
            *
            * Desc: Highlights an input field for 1500ms.
            * Note: "HACK": when input_weekly_NumberOfWeeks change in the above line the cssClassList
            * Note: will change, so if we want to change the cssClassList too, we need to wait
            *
            * @param {string} fieldName (ref name of input field)
            *
            */
            onChange_highlightField: function(fieldName) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> onChange_highlightField');
                if (me.$refs[fieldName] && me.$refs[fieldName].$el) {
                    setTimeout(function() {
                        me.$refs[fieldName].$el.classList.add('input-glow');
                    }, 100);

                    setTimeout(function() {
                        me.$refs[fieldName].$el.classList.remove('input-glow');
                    }, 1600);
                }

            }, // eo function onChange_highlightField()


            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            * Note:
            *
            * @param {Object} date (date to format)
            */
            formatDateForTextField: function(date) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date, { showDayName: true });

            }, // eo function formatDateForTextField()


            /*******************************************************************
            * setDatesInRange()
            *
            * Desc: Modify the date with the utc filter.
            *
            * @param {Object} date ()
            * @returns {Object} ({total:number,weeks:number,dates:Array<Object>,months:Array<string>})
            */
            setDatesInRange: function() {

                const me = this,
                    datesInRange = {
                        total: 0,
                        weeks: 0,
                        dates: [],
                        months: []
                    };
                let tmp_start,
                    tmp_end,
                    tmp;


                me.$toc('>>> views/flights/flights/components/crud/Step2DateConfig.vue >>> setDatesInRange');
                if (me.data[me.leg].input_weekly_StartDate && me.data[me.leg].input_weekly_EndDate && me.data[me.leg].input_weekly_DaysOfWeek) {

                    tmp_start = dayjs(me.data[me.leg].input_weekly_StartDate);
                    tmp_end = dayjs(me.data[me.leg].input_weekly_EndDate);
                    //loop over selected days
                    me.data[me.leg].input_weekly_DaysOfWeek.forEach(day => {

                        tmp = tmp_start.clone();

                        //get next (selected) day in time range
                        //if startDate is a that week already passed the selected day
                        //go on one week, and select the selected day
                        //dayjs.day(#number) only moves in the current week of startDate,
                        //even if the day is in the past
                        if (tmp_start.get('day') !== day.dayOfWeek) {
                            tmp = tmp_start.add(1, 'week');
                        }
                        tmp = tmp.day(day.dayOfWeek);
                        // check - push - go on 7 days
                        while (tmp.isSameOrBefore(tmp_end)) {
                            datesInRange.dates.push(tmp);
                            datesInRange.total += 1;
                            tmp = tmp.add(7, 'days');
                        }
                    });

                    datesInRange.dates.sort((a, b) => a.isAfter(b) ? 1 : -1);

                    datesInRange.weeks = tmp_end.diff(tmp_start, 'weeks');

                    datesInRange.dates.forEach((date) => {
                        const month = dayjs(date).format('MMMM YYYY');

                        if (datesInRange.months.includes(month) === false) {
                            datesInRange.months.push(month);
                        }
                    });
                }

                me.data[me.leg].weekly_datesInRange = datesInRange;
                me.data[me.leg].input_weekly_NumberOfWeeks = datesInRange.weeks;


                return datesInRange;

            } // eo function setDatesInRange()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    /* Combobox need to be "readonly", but chips need to displayed "normal" */
    .sdr-custom-dates-combobox .v-chip--disabled {
        opacity: 1;
        color: rgba(0, 0, 0, 0.87) !important;
    }
</style>
